<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">შექმენით ორგანიზაცია</h5>
        <form class="add-organization-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="createOrganization">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="orgName" class="ms-2">ორგანიზაციის სახელი(ქართულად)</label>
            <input v-model="organizationDataVModels.org_name" type="text" autocomplete="off" name="orgName" id="orgName" required placeholder="ორგანიზაციის სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="orgEngName" class="ms-2">(ინგლისურად)ორგანიზაციის სახელი</label>
            <input v-model="organizationDataVModels.org_nameeng" type="text" autocomplete="off" name="orgEngName" id="orgEngName" required placeholder="(ინგლისურად)ორგანიზაციის სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="orgCode" class="ms-2">ორგანიზაციის კოდი</label>
            <input v-model="organizationDataVModels.org_code" type="password" autocomplete="off" name="orgCode" id="orgCode" required placeholder="ორგანიზაციის კოდი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="orgLogo" class="ms-2">ორგანიზაციის ლოგო</label>
            <input ref="logoInput" type="file" accept="image/jpeg" autocomplete="off" name="orgLogo" id="orgLogo" required placeholder="აირჩიეთ სურათი ლოგოსთვის" class="blue-part-input large-text">
          </fieldset>
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
export default {
  data(){
    return {
      organizationDataVModels: {
        org_name: "",
        org_nameeng: "",
        org_code: "",
      },
      isSending: false,
    }
  },
  components: {
    secondaryButton,
  },
  methods: {
    checkLogo(file){
      if(file && this.$refs.logoInput?.files.length == 1){
        const validImageTypes = ['image/jpeg'];
        if (!validImageTypes.includes(decodeURIComponent(file.type))) {
          return false;
        }
        return true;
      }
      return false;
    },
    createOrganization(){
      // let isNameValid = this.$helper.checkString(this.organizationDataVModels.org_name);
      // let isEngNameValid = this.$helper.checkEngString(this.organizationDataVModels.org_nameeng);
      // let isPasswordValid = this.$helper.checkPassword(String(this.organizationDataVModels.org_code));
      // console.log(isNameValid);
      // console.log(isEngNameValid);
      // console.log(isLogoValid);
      // console.log(isPasswordValid);
      let isLogoValid = this.$helper.checkJpeg(this.$refs.logoInput?.files[0]);

      
      if(this.organizationDataVModels.org_name && this.organizationDataVModels.org_nameeng && isLogoValid && this.organizationDataVModels.org_code){
        this.isSending = true;
        
        const formData = new FormData();
        for(let key of Object.keys(this.organizationDataVModels)){
          formData.append(key, this.organizationDataVModels[key]);
        }
        formData.append('org_logo', this.$refs.logoInput?.files[0]);
        
        this.$store.dispatch("createOrganization", formData).then((response) => {
          if(response.status == 201){
            this.$helper.showSwal("ორგანიზაცია წარმატებით დაემატა", "success", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).catch((error) => {
          if(error?.response?.status == 422){
            this.$helper.showSwal("მოხდა შეცდომა", "error", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).finally(() => {
          this.isSending = false;
        })
      }
    }
  }
}
</script>
<style scoped>
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(1, min-content);
  row-gap: 1.5em;
}
.add-organization-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper{
  grid-column: 1/3;
}


@media screen and (max-width: 1800px) {
  .add-organization-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-organization-form{
    width: 90%;
  }
}
</style>
